import { useLang } from "@/i18n";

const ITEMS_IT =
  "Circolo Vela Manerba del Garda • Sport • Natura • Avventura • Rocca di Manerba • Isola dei Conigli • Il kayak per tutti • Nessun pagamento online • Prenota il tuo posto • ";
const ITEMS_EN =
  "Circolo Vela Manerba del Garda • Sport • Nature • Adventure • Rocca di Manerba • Rabbit Island • Kayaking for everyone • No online payment • Book your spot • ";

export default function Marquee() {
  const { lang } = useLang();
  const text = lang === "it" ? ITEMS_IT : ITEMS_EN;
  return (
    <div
      data-testid="editorial-marquee"
      className="relative bg-gold text-lake-deep overflow-hidden py-4 border-y border-lake-deep/10 select-none"
    >
      <div className="flex whitespace-nowrap animate-marquee w-max">
        {[0, 1].map((i) => (
          <span key={i} className="font-serif italic text-xl sm:text-2xl tracking-wide pr-4">
            {text.repeat(3)}
          </span>
        ))}
      </div>
    </div>
  );
}
